
























































import StudentParentInfoPage from './StudentParentInfoPage.vue';
import StudentInfoPage from './StudentInfoPage.vue';
import StudentCommunicationPage from './StudentCommunicationPage.vue';
import StudentEducationalEnvPage from './StudentEducationalEnvPage.vue';
import StudentPaymentPage from './StudentPaymentPage.vue';
import StudentOpportunityPage from './StudentOpportunityPage.vue';
import StudentInputCofirmPage from './StudentInputCofirmPage.vue';
import RequiresAnnounce from '../../components/atoms/RequiresAnnounce.vue';
import { Session } from '../../utils/Session';
import { StudentInfoInputDTO } from '../../../src_server/entity/dto/StudentInfoInputDTO';
import { Vue, Component } from 'vue-property-decorator';
import { PageValidate } from '../../utils/PageValidate';
import { InputPages } from '../../components/organisms/InputPages';
import { MessageDialog } from '../../utils/MessageDialog';
import { StudentService } from '../../biz/remote/StudentService';
import { routeHelper } from '../../utils/routeHelper';
import { scrollToTop } from '../../utils/viewAction';

@Component({
  components: {
    StudentParentInfoPage,
    StudentInfoPage,
    StudentCommunicationPage,
    StudentEducationalEnvPage,
    StudentPaymentPage,
    StudentOpportunityPage,
    StudentInputCofirmPage,
    RequiresAnnounce,
  },
})
export default class StudentInfoInputMain extends Vue {
  info: StudentInfoInputDTO = new StudentInfoInputDTO();

  currentPage = 0;

  // private error_summary = '';

  get all(): boolean {
    return !this.hasNext;
  }

  get forDisplay(): boolean {
    return !this.hasNext;
  }

  get pageTitles() {
    this.pages.forEach((p: any, index: number) => (p.index = index));
    return this.pages;
  }

  pages = [
    { name: 'StudentParentInfoPage', title: '保護者の情報の入力' },
    { name: 'StudentInfoPage', title: 'お子様の情報の入力' },
    { name: 'StudentCommunicationPage', title: 'コミュニケーション手段' },
    { name: 'StudentEducationalEnvPage', title: 'お子様の教育環境について' },
    { name: 'StudentOpportunityPage', title: 'お申し込みのきっかけ' },
    { name: 'StudentInputCofirmPage', title: '入力確認' },
  ];

  get title(): string {
    return `${this.pageTitles[this.currentPage].title}(${this.currentPage + 1}/${this.pageTitles.length})`;
  }

  save(): void {
    // セッション上に保存
    // Session.set<StudentInfoInputDTO>('STUDENT_INFO_INPUTING', this.info);
  }

  backPage(): void {
    this.currentPage--;
    this.save();
  }

  get hasNext(): boolean {
    return this.pageTitles.length > this.currentPage + 1;
  }

  next(): void {
    const pageName = this.pageTitles[this.currentPage].name;
    const page = this.$refs[pageName] as Vue;

    if (!PageValidate.validate(page.$refs)) {
      // エラーがなければ保存して進む
      scrollToTop();
      this.save();
      this.currentPage++;
    }
    scrollToTop();

    const pageValidable = page as InputPages;
    pageValidable.validate();
    // this.error_summary = pageValidable.error_summary.join('<br>');
  }

  updated(): void {
    console.log(this.info);
    this.save();
  }

  mounted(): void {
    this.pageTitles.forEach((page) => {
      (this.$refs[page.name] as InputPages).title = this.pageTitles.filter((p) => p.name === page.name)[0].title;
    });
    scrollToTop();
  }

  created(): void {
    // 途中のデータを取り出す
    console.log(this.info);
    // this.info = Session.get<StudentInfoInputDTO>('STUDENT_INFO_INPUTING') ?? new StudentInfoInputDTO();
  }

  async register() {
    this.save();
    const result = await MessageDialog.confirm('登録しますよろしいですか？');
    if (result) {
      const biz = new StudentService();
      try {
        await biz.setStudentInfo(Session.getSessionUserId(), this.info, Session.getSessionBuildingId());
        if (Session.getContext()?.is_billing_term) {
          // NOTE: 2021/2/15 日本財団からの出資期間中なので、無償提供。カードは入力しないようにする
          routeHelper(this, 'StudentPaymentReset');
        } else {
          routeHelper(this, 'StudentInfoInputComplete');
        }
      } catch (error) {
        await MessageDialog.alert(error);
      }
    }
  }
}
